import untils from "../untils";
import Cookies from "js-cookie";
export default {
  showLoading: false,
  showNav:false,
  typeName:"",
  navName:"",
  isShowNav:true,
  ssid: untils.getCookie("ssid"),
  userName: untils.getCookie("username"),
  login: null, //登录
  permissionList: [], //获取权限
  scrollTop: 0,
  scrollLeft: 0,
  pageSize: 16,
  size: Cookies.get("fontsize") || "16"
};
